export default {
  title: '特定的问题',
  btn: {
    invite: '邀请'
  },
  message: {
    inviteTip: [
      '这部分允许您创建一些简短的问题，申请人必须完成这些问题才能完成初步筛选。',
      '有五种题：一种是允许申请人任意作答的问答题，一种是选择题，一种是视频答题，一种是附件答题，还有一种是日期答题。'
    ],
    knockoutTip: '选择题中红色选项为淘汰项。',
    inviteSuccess: '邀请成功',
    inviteSuccessInfo: '邀请成功 {successCount} 人，失败 {failCount} 人'
  }
}
